module.exports = "img/element-icons/room/default_clock.d7c6411.svg";